// extracted by mini-css-extract-plugin
export var boldText = "_7i-4";
export var checkboxContainer = "_7i-6";
export var closeIcon = "_7i-i";
export var container = "_7i-0";
export var drawer = "_7i-8";
export var drawerContent = "_7i-9";
export var extraSmallText = "_7i-5";
export var fulfillmentGroupTable = "_7i-e";
export var largeText = "_7i-3";
export var loadingSpinnerContainer = "_7i-j";
export var mediumText = "_7i-2";
export var narrow = "_7i-f";
export var notificationLink = "_7i-l";
export var packageCheckIconContainer = "_7i-7";
export var slideoutHeaderActions = "_7i-g";
export var slideoutHeaderActionsShifted = "_7i-h";
export var slideoutHeaderContainer = "_7i-a";
export var slideoutModal = "_7i-c";
export var stickyHeaderWrapper = "_7i-b";
export var table = "_7i-k";
export var tableContainer = "_7i-d";
export var tertiaryText = "_7i-1";